import { render, staticRenderFns } from "./ListNewsFeatured.vue?vue&type=template&id=49e969dc&scoped=true&"
import script from "./ListNewsFeatured.vue?vue&type=script&lang=js&"
export * from "./ListNewsFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListNewsFeatured.vue?vue&type=style&index=0&id=49e969dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e969dc",
  null
  
)

export default component.exports